var pdTools = pdTools || {};

pdTools.arrayUnion = function(x, y) {
	if (! Array.isArray(x))
		x = [x];

	if (! Array.isArray(y))
		y = [y];

	var res = x.slice(0);
	var l = y.length;

	for (var i = 0; i < l; i++) {
		if (res.indexOf(y[i]) === -1)
			res.push(y[i]);
	}

	return res;
};

// Get viewport width including scrollbar, therefore same as using css media queries
pdTools.getViewportWidth = function() {
	return Math.max(document.documentElement.clientWidth, window.innerWidth);
};
